export const ROLES = {
  SYSTEM_OWNER: "SYSTEM_OWNER",
  SECURITY_ADMIN: "SECURITY_ADMIN",
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
  OPERATIONS_MANAGER: "OPERATIONS_MANAGER",
  ONBOARDING_MANAGER: "ONBOARDING_MANAGER",
  MEDICAL_COMPLIANCE_REVIEWER: "MEDICAL_COMPLIANCE_REVIEWER",
  LABOR_COMPLIANCE_OFFICER: "LABOR_COMPLIANCE_OFFICER",
  TRAINING_MANAGER: "TRAINING_MANAGER",
  PAYROLL_PREPARER: "PAYROLL_PREPARER",
  PAYROLL_REVIEWER: "PAYROLL_REVIEWER",
  PAYROLL_PUBLISHER: "PAYROLL_PUBLISHER",
  SCHEDULE_EDITOR: "SCHEDULE_EDITOR",
  SCHEDULE_REVIEWER: "SCHEDULE_REVIEWER",
  STORE_MANAGER: "STORE_MANAGER",
  EMPLOYEE: "EMPLOYEE",
  READ_ONLY_AUDITOR: "READ_ONLY_AUDITOR",
};

export const MANAGEMENT_ROLES = [
  ROLES.SYSTEM_OWNER, ROLES.SECURITY_ADMIN, ROLES.SYSTEM_ADMIN, ROLES.OPERATIONS_MANAGER,
  ROLES.ONBOARDING_MANAGER, ROLES.MEDICAL_COMPLIANCE_REVIEWER, ROLES.LABOR_COMPLIANCE_OFFICER,
  ROLES.TRAINING_MANAGER, ROLES.PAYROLL_PREPARER, ROLES.PAYROLL_REVIEWER, ROLES.PAYROLL_PUBLISHER,
  ROLES.SCHEDULE_EDITOR, ROLES.SCHEDULE_REVIEWER, ROLES.STORE_MANAGER, ROLES.READ_ONLY_AUDITOR,
];

// Mirrors backend constants/roles.py ROLE_TO_DOMAIN - used to restrict role-change
// dropdowns to roles compatible with the account's existing domain.
export const ROLE_TO_DOMAIN = {
  ...Object.fromEntries(MANAGEMENT_ROLES.map((r) => [r, "MANAGEMENT"])),
  [ROLES.EMPLOYEE]: "STAFF",
};

export function rolesForDomain(domain) {
  return Object.entries(ROLE_TO_DOMAIN).filter(([, d]) => d === domain).map(([role]) => role);
}

export const EMPLOYMENT_TYPES = ["FULL_TIME", "PART_TIME", "CONTRACT"];

export const WORK_STATUSES = ["ACTIVE", "INACTIVE", "NO_LONGER_WORKING"];

export const DOCUMENT_CATEGORIES = [
  "IDENTIFICATION", "WORK_AUTHORIZATION", "CONTRACT", "POLICY_ACKNOWLEDGMENT", "PERSONAL_INFORMATION", "OTHER",
];

export const REASON_CATEGORIES = [
  "UNREADABLE", "WRONG_DOCUMENT", "EXPIRED_DOCUMENT", "MISSING_PAGE", "NAME_MISMATCH",
  "INFORMATION_INCOMPLETE", "INCORRECT_FILE", "OTHER",
];

export const EMPLOYMENT_PERIOD_TYPES = ["INDEFINITE", "FIXED_TERM"];

export const WAGE_TYPES = ["HOURLY", "DAILY", "MONTHLY"];

export const VOTING_METHODS = ["SECRET_DIGITAL_BALLOT", "PAPER_BALLOT", "IN_PERSON", "OTHER_APPROVED"];

export const CORRECTIVE_ACTION_STATUSES = ["NOT_STARTED", "IN_PROGRESS", "READY_TO_SUBMIT", "SUBMITTED", "ACCEPTED"];
